export default "__VITE_ASSET__f54830af__"